import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
// import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
// import Paper from "@material-ui/core/Paper";
import constants from "../../constants/tutorialAutomaton";
import { useUser } from "../../context/userContext";
import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/material-dashboard-react/components/dialogHistorical";
// import connect from "../../assets/img/ConnectState.png";
import "./classes.css";
// import { Button } from "@material-ui/core";
import { DialogActions } from "@material-ui/core";
import { useGrammar } from "context/grammarContext";
import DropzoneGrammar from "components/Dropzone/DropzoneGrammar";
// import { Button } from "@material-ui/core";
// const percent = "100%";

import importConstants from "constants/Dialogs/ImportConstants/importConstants";

const useStyles = makeStyles(styles);

export default function ImportGrammarDialog() {
  const { language } = useUser();
  const { isActiveDialogImportGrammar, setActiveDialogImportGrammar } =
    useGrammar();

  //   const [texts, setTexts] = useState([]);
  const [checked, setChecked] = useState(true);
  //   const [spacing] = React.useState(2);
  const classes = useStyles();

  const handleClose = () => {
    setActiveDialogImportGrammar(false);
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  return (
    <div>
      <Dialog
        checked={checked}
        onChange={handleChange}
        open={isActiveDialogImportGrammar}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle className={classes.dialog} id="alert-dialog-slide-title">
          {constants.modal.importGrammar[language]}
        </DialogTitle>
        <DialogContent className={classes.dialog}>
          <DropzoneGrammar
            setOpen={setActiveDialogImportGrammar}
            text={importConstants.importDialog.text[language]}
          />
        </DialogContent>
        <DialogActions className={classes.dialog}></DialogActions>
      </Dialog>
    </div>
  );
}
